import React, { useState, useEffect, useContext } from "react";
import styles from "./BatchRemewModal.module.css";
import { apiUrl } from "../../Constants/Constants";
import NumberComponent from "../../Components/NumberComponent";
// import FetchWithToken from "../FetchWithToken/FetchWithToken";
import { AuthContext } from "../../Constants/AuthProvider";
import { redirect } from "react-router-dom";
import { useFetchWithToken } from "../../Components/FetchWithToken/FetchWithToken";
import { ConfirmationModalContext } from "../../fautures/ConfirmationModalProvider";
import { accountRenewBatchLogic } from "./accountRenewBatchLogic";
import CtaBtns from "../../Components/CtaBtns/CtaBtns.module";
import CheckBox from "../../Components/CheckBox/CheckBox.module";
import BackButton from "../../Components/BackButton/BackButton.module";
import BlueBtn from "../../Components/BlueBtn/BlueBtn.module";
import AutoRenewModal from "../../Components/AutoRenewModal/AutoRenewModal.module";
import { useModalManager } from "../../hooks/useModalManager";
import LoadingCircl from "../../Components/LoadingCircl/LoadingCircl.module";
import DiscountPart from "../../Components/DiscountPart/DiscountPart.module";
const AccountRenew = ({ userWallet, loadingShow, onClose }) => {
  const modalContext = useContext(ConfirmationModalContext);
  const [titlIng, setTitlIng] = useState("انتخاب اکانت ");
  const [receivedData, setReceivedData] = useState(null);
  const { onLogout } = React.useContext(AuthContext);
  const [accounts, setAccounts] = useState([]);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [littleLoad, setLittleLoads] = useState(true);
  const { loading, fetchWithToken } = useFetchWithToken();
  const [discountCode, setDiscountCode] = useState(null);
  const [finalPrice, setFinalPrice] = useState(null);
  const [changeAllowed, setChangeAllowed] = useState(true);
  const modalList = [
    "batchRenew",
    "autoRenew",
    "transaction",
    "pricing",
    "trafficBuy",
    "addCredit",
    "confirm",
    "payReserved",
  ];
  const { openModal, closeModal, isOpen, getPayload } =
    useModalManager(modalList);
  const formatPrice = (price) => {
    if (price == null) return "در حال بارگذاری...";
    return `${price.toLocaleString("fa-IR")} تومان`;
  };
  const getInfo = () => {
    fetchWithToken(apiUrl + "user/dashboard-details", {
      method: "GET",
    }).then((data) => {
      setReceivedData(data.data);

      if (data.status === "401") {
        onLogout();
      }
    });
  };
  useEffect(() => {
    getInfo();
  }, []);
  const { fetchPaymentUrl, paybatchRenewPay } = accountRenewBatchLogic(
    {
      fetchWithToken,
      getInfo,
      onLogout,
      closeFinalModal: onClose,
      getInfo,
      loadingShow,
      loading,
    },
    modalContext
  );
  useEffect(() => {
    if (receivedData) {
      setLittleLoads(false);
    }
  }, [receivedData]);
  // دریافت لیست اکانت‌ها هنگام باز شدن مودال
  useEffect(() => {
    const loadAccounts = async () => {
      if (receivedData?.profiles) {
        const data = await receivedData?.profiles;
        const filteredAccounts = data?.filter(
          (account) => account.remainingTime.days < 2 && account.price !== 0
        );
        setAccounts(filteredAccounts);
      }
    };
    loadAccounts();
  }, [receivedData]);

  // مدیریت انتخاب/عدم انتخاب اکانت
  const handleSelect = (accountId) => {
    setSelectedAccounts(
      (prev) =>
        prev.includes(accountId)
          ? prev.filter((id) => id !== accountId) // حذف از لیست انتخاب‌شده
          : [...prev, accountId] // افزودن به لیست انتخاب‌شده
    );
  };
  const fetchAccounts = async () => {
    return await receivedData?.profiles;
  };

  // محاسبه مجموع مبلغ
  const calculateTotal = () => {
    if (selectedAccounts.length != 0 && accounts.length != 0) {
      return selectedAccounts.reduce((sum, accountId) => {
        const account = accounts.find((acc) => acc.id === accountId);
        const price = account.discounts
          ? account.discounts.priceAfterDiscount
          : account.price;
        return sum + price;
      }, 0);
    } else {
      setCurrentStep(1);
    }
  };
  useEffect(() => {
    switch (currentStep) {
      case 1:
        setTitlIng("انتخاب اکانت ");
        break;
      case 2:
        setTitlIng("صورتحساب شما");
        break;
      case 3:
        setTitlIng("انتخاب محل پرداخت");
        break;
    }
  }, [currentStep]);

  return (
    <>
      <BackButton />
      <div className={styles.btnonautorenew}>
        <CtaBtns onAtion={() => openModal("autoRenew")}>
          تمدید خودکار اکانت ها
        </CtaBtns>
      </div>
      <div className={styles.accList} onClick={onClose}>
        <div onClick={(e) => e.stopPropagation()}>
          {/* <div className={styles.topBoxIcons}>
            <div className={styles.rightIconTop}>
              <i class="fa-solid fa-cart-plus"></i>
            </div>
          </div> */}
          <div className={styles.titleAddAccount}>
            <i className="fas fa-fa-solid fa-repeat"></i>
            تمدید اکانت ها
          </div>

          <div className={styles.renewtitle}>{titlIng}</div>
          {!littleLoad ? (
            <>
              {currentStep === 1 && (
                <>
                  {accounts?.length !== 0 ? (
                    <>
                      <p className={styles.descrenew}>
                        لطفاً اکانت‌هایی که می‌خواهید تمدید شوند را انتخاب کنید:
                      </p>
                      <div className={styles.accountlist}>
                        {accounts?.map((account) => (
                          <div
                            key={account.id}
                            className={`${styles.accountcard} ${
                              selectedAccounts.includes(account.id)
                                ? styles.selected
                                : ""
                            }`}
                            onClick={() => handleSelect(account.id)}
                          >
                            <CheckBox
                              checked={selectedAccounts.includes(account.id)}
                            />
                            {"discounts" in account ? (
                              <>
                                <p>
                                  <span className={styles.discountedprice}>
                                    {formatPrice(
                                      account.discounts.priceAfterDiscount
                                    )}
                                  </span>
                                  <span className={styles.originalprice}>
                                    {formatPrice(account.price)}
                                  </span>
                                </p>
                                <p>
                                  <span className={styles.discountpercent}>
                                    {NumberComponent(
                                      account.discounts.discountPercent
                                    )}
                                    %
                                  </span>{" "}
                                  تخفیف
                                </p>
                              </>
                            ) : (
                              <p className={styles.price}>
                                {formatPrice(account.price)}
                              </p>
                            )}
                            <p className={styles.remainingtime}>
                              {NumberComponent(account.remainingTime.days)} روز
                              مانده
                            </p>
                            <div className={styles.tit}>
                              {account.accountName}
                              <i class="far fa-user"></i>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    <div
                      style={{
                        fontFamily: "light",
                        color: "white",
                        textAlign: "center",
                        direction: "rtl",
                      }}
                    >
                      هیچ یک از اکانت های شما به موعد تمدید نزدیک نیستند.
                    </div>
                  )}

                  <div className={styles.modalactions}>
                    <CtaBtns
                      className={styles.gonext}
                      onAtion={() => setCurrentStep(2)}
                      disabled={selectedAccounts.length === 0}
                    >
                      مشاهده صورتحساب
                    </CtaBtns>
                  </div>
                </>
              )}

              {currentStep === 2 && (
                <>
                  <p className={styles.accountcount}>
                    تعداد اکانت‌ها: {NumberComponent(selectedAccounts.length)}
                  </p>
                  <div className={styles.accountlist2}>
                    {selectedAccounts.map((accountId) => {
                      const account = accounts.find(
                        (acc) => acc.id === accountId
                      );
                      return (
                        <div
                          key={account.id}
                          className={`${styles.accountcard} ${styles.selected}`}
                        >
                          <div className={styles.tit}>
                            {account.accountName}
                          </div>

                          {"discounts" in account ? (
                            <>
                              <p>
                                <span className={styles.discountedprice}>
                                  {formatPrice(
                                    account.discounts.priceAfterDiscount
                                  )}
                                </span>
                                <span className={styles.originalprice}>
                                  {formatPrice(account.price)}
                                </span>
                              </p>
                              <p>
                                <span className={styles.discountpercent}>
                                  {NumberComponent(
                                    account.discounts.discountPercent
                                  )}
                                  %
                                </span>
                                تخفیف
                              </p>
                            </>
                          ) : (
                            <p className={styles.price}>
                              {formatPrice(account.price)}
                            </p>
                          )}
                          <p>
                            {NumberComponent(account.remainingTime.days)} روز
                            مانده
                          </p>
                        </div>
                      );
                    })}
                  </div>
                  <div className={styles.invoiceSummary}>
                    <p>
                      مجموع مبلغ قابل پرداخت: {formatPrice(calculateTotal())}
                    </p>
                  </div>
                  <div className={styles.modalactions}>
                    <CtaBtns
                      className={styles.goback}
                      onAtion={() => setCurrentStep(1)}
                    >
                      بازگشت
                    </CtaBtns>
                    <CtaBtns
                      className={styles.gonext}
                      onAtion={() => setCurrentStep(3)}
                    >
                      پرداخت
                    </CtaBtns>
                  </div>
                </>
              )}

              {currentStep === 3 && (
                <>
                  <div className={styles.invoiceSummary}>
                    <DiscountPart
                      setChangeAllowed={setChangeAllowed}
                      changeAllowed={changeAllowed}
                      setFinalPrice={setFinalPrice}
                      accounts={selectedAccounts}
                      totalPrice={calculateTotal()}
                      formatPrice={formatPrice}
                      discountCode={discountCode}
                      setDiscountCode={setDiscountCode}
                    />
                  </div>

                  <div className={styles.choosepayment}>
                    <div
                      className={
                        finalPrice > receivedData?.remainingWallet
                          ? `${styles.eachitemonpayment} ${styles.disablePayment}`
                          : styles.eachitemonpayment
                      }
                      onClick={() =>
                        finalPrice <= receivedData?.remainingWallet &&
                        paybatchRenewPay(
                          selectedAccounts,
                          finalPrice,
                          !changeAllowed && discountCode
                        )
                      }
                    >
                      <div className={styles.topicon}>
                        <i class="fa-light fa-wallet"></i>
                      </div>
                      <div className={styles.textofpay}>
                        کیف پول
                        {calculateTotal() > userWallet && (
                          <>
                            <br />
                            عدم موجودی کافی
                          </>
                        )}
                      </div>
                    </div>
                    <div
                      className={styles.eachitemonpayment}
                      onClick={() =>
                        fetchPaymentUrl(selectedAccounts, discountCode)
                      }
                    >
                      <div className={styles.topicon}>
                        <i class="fa-light fa-credit-card-front"></i>
                      </div>
                      <div className={styles.textofpay}>درگاه پرداخت</div>
                    </div>
                  </div>
                  <div className={styles.modalactions}>
                    <CtaBtns
                      className={styles.goback}
                      onAtion={() => setCurrentStep(2)}
                    >
                      بازگشت
                    </CtaBtns>
                  </div>
                </>
              )}
            </>
          ) : (
            <div className={styles.centerin}>
              <LoadingCircl />
            </div>
          )}
        </div>
      </div>
      <AutoRenewModal
        isOpen={isOpen("autoRenew")}
        onClose={() => {
          closeModal("autoRenew");
        }}
        getInfo={getInfo}
        fetchAutoRenewableAccounts={fetchAccounts}
      />
    </>
  );
};

export default AccountRenew;
